
import { TipoServicio } from "../../services/ventasServicios";
import ServicioBadge from "./ServicioBadge";

function ServiciosBadges({ servicios }: { servicios: TipoServicio[] }) {
  let serviciosOrdenados = servicios.sort((servA, servB) =>
    servA.toString().localeCompare(servB.toString())
  );

  return (
    <>
      {serviciosOrdenados.map((servicio) => (
        <ServicioBadge servicio={servicio} />
      ))}
    </>
  );
}

export default ServiciosBadges;
